import React from 'react';
import { Stack, TextField } from '@mui/material';
import { isCustomerFieldRequired, type CustomerFieldErrorMap } from '../../customerCompleteness';
import type { CustomerFormDraft } from '../../customerFormDraft';

type Props = {
  draft: CustomerFormDraft;
  onChange: (patch: Partial<CustomerFormDraft>) => void;
  readOnly?: boolean;
  fieldErrors?: CustomerFieldErrorMap;
  requiredKeys?: ReadonlySet<keyof CustomerFormDraft>;
};

/** Diskon & catatan. */
export function CustomerFormCommercialNotesTabScreen({
  draft,
  onChange,
  readOnly = false,
  fieldErrors,
  requiredKeys,
}: Props) {
  const req = (key: keyof CustomerFormDraft) =>
    isCustomerFieldRequired(key, { readOnly, requiredKeys });
  return (
    <Stack spacing={2} sx={{ maxWidth: 560 }}>
      <TextField
        label="Diskon (%)"
        value={draft.discount}
        onChange={(e) => onChange({ discount: e.target.value })}
        required={req('discount')}
        error={Boolean(fieldErrors?.discount)}
        helperText={fieldErrors?.discount ?? 'Angka desimal boleh memakai titik atau koma.'}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-discount' }}
      />
      <TextField
        label="Catatan"
        value={draft.notes}
        onChange={(e) => onChange({ notes: e.target.value })}
        required={req('notes')}
        error={Boolean(fieldErrors?.notes)}
        helperText={fieldErrors?.notes}
        fullWidth
        multiline
        minRows={4}
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-notes' }}
      />
    </Stack>
  );
}
